import {
  consignmentOrderBillingTableOpt,
  filterConst,
} from '../../../../constants/ConsignOrderBilling.const';
import { EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import {
  cancelConsigmentOrderBillingModal,
  modalButtons,
  notDeleteableStatus,
  roleConst,
  UrlPaths,
} from '../../../../constants';
import { Dropdown, Menu } from 'antd';
import confirm from 'antd/lib/modal/confirm';
import { filterOptionsConst } from '../../../../constants/FilterOptions';
import { useNavigate } from 'react-router-dom';

export const ConsignOrderBillingTableOptions = ({
  id = null,
  action = {},
  status = '',
  privileges = [],
  role = null,
  numberOrder,
  consignmentOrderId,
}) => {
  const navigate = useNavigate();
  const { onDelete } = !!action && action;
  const isPaid = status === filterOptionsConst.PAID;

  let options = consignmentOrderBillingTableOpt()
    .filter((opt) => privileges.includes(opt.privilege))
    .filter((opt) => {
      if (isPaid) {
        return opt.key === filterConst.EDIT || opt.key === filterConst.PDF;
      }
      return opt.key !== filterConst.PDF;
    });

  if (roleConst.branchManager === role) {
    options.push({
      label: 'Editar',
      key: 'edit',
      icon: <EditOutlined />,
      privilege: 'edit',
    });
  }

  if (notDeleteableStatus.includes(status)) {
    options = options.filter((opt) => opt.key !== filterOptionsConst.DELETE);
  }

  const renderMenu = (id) => {
    return (
      <Menu
        onClick={({ key }) => handleMenuClick(key, id, numberOrder)}
        items={options}
      />
    );
  };

  const handleMenuClick = (key, id, numberOrder) => {
    switch (key) {
      case 'edit':
        navigate(
          UrlPaths.CONSIGNMENT_ORDER_BILLING_EDIT(
            consignmentOrderId,
            numberOrder,
            id
          )
        );
        break;
      case 'cancel':
        showDeleteConfirm();
        break;
      case 'pdf':
        window.open(
          `${process.env.REACT_APP_API}/v${process.env.REACT_APP_API_VERSION}/consignment-order-billing/${id}/download`,
          '_blank',
          'noopener,noreferrer'
        );
        break;
      default:
        break;
    }
  };

  const showDeleteConfirm = () => {
    confirm({
      title: cancelConsigmentOrderBillingModal.title,
      icon: <ExclamationCircleOutlined />,
      content: cancelConsigmentOrderBillingModal.body,
      okType: 'danger',
      okText: modalButtons.confirm,
      cancelText: modalButtons.cancel,
      onOk() {
        return new Promise((resolve) => {
          setTimeout(resolve(onDelete.action(...onDelete.params)), 1000);
        });
      },
      onCancel() {},
    });
  };

  return (
    <Dropdown.Button
      disabled={!(options.length > 0)}
      overlay={renderMenu(id)}
      trigger={['click']}
      placement="bottom"
    />
  );
};
